import { MeterAppointmentService } from "@/services/MeterAppointmentService"
import { sortedFeedItems } from "./getActivityFeedEvents"
import {
  ActivityFeedItemType,
  MeterAppointmentFeedItem,
  IItemsByDate,
} from "@/models/activityFeed/ActivityFeedItem"
import { MeterAppointment } from "@/models/meterAppointment/meterAppointment"
import { IMeterAppointment } from "@/models/meterAppointment/meterAppointment.types"
import {
  QueryAggregator,
  AggregatedQueryProps,
} from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"

export const getMeterAppointmentEvents = (
  accountNumber: string,
): AggregatedQueryProps<IItemsByDate[]> => {
  const queries = new QueryAggregator()
  const meterAppointments: ActivityFeedItemType[] = []

  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  queries.add(coreIdQuery)

  if (coreIdQuery.data) {
    getMeterAppointments(coreIdQuery.data)
  }

  function getMeterAppointments(billingAccountId: number) {
    const meterAppointmentsQuery =
      MeterAppointmentService.getAppointments(billingAccountId)

    queries.add(meterAppointmentsQuery)

    const feedItems: ActivityFeedItemType[] = flattenAppointments(
      meterAppointmentsQuery.data,
    ).map((data) => {
      return new MeterAppointmentFeedItem(data)
    })

    meterAppointments.push(...feedItems)
  }

  return queries.setData(sortedFeedItems(meterAppointments)).getAggregate()
}

function flattenAppointments(appointments: IMeterAppointment[]) {
  return appointments.reduce(
    (total: IMeterAppointment[], current: IMeterAppointment) => {
      let historyOfAppointment: MeterAppointment[] = []

      if (current?.history) {
        historyOfAppointment = current?.history.reduce(
          (
            totalHistory: IMeterAppointment[],
            currentHistory: IMeterAppointment,
          ) => {
            return [currentHistory, ...totalHistory]
          },
          [],
        )
      }

      return [current, ...total, ...historyOfAppointment]
    },
    [],
  )
}
